import $ from 'jquery';
import 'jquery.easing';

const toggler = $('.secondary-nav-tree .caret');
//
// $(toggler).each((_, tog) => {
//   $(tog).on('click', function(e) {
//     console.log('whyyy', this)
//     $('.secondary-nav-tree li').removeClass('active');
//     $(this)
//       .find('.nested')
//       .toggleClass('active')
//
//     $(this).toggleClass('.caret-down');
//   });
// });

if (Array.isArray(toggler)) {
    Array.from(toggler).forEach(tog => {
        tog.addEventListener("click", function () {
            this.parentElement.querySelector(".nested").classList.toggle("active");
            this.classList.toggle("caret-down");
        });
    })
}
